import { render, staticRenderFns } from "./BtnComprometimentoPagamento.vue?vue&type=template&id=54831806"
import script from "./BtnComprometimentoPagamento.vue?vue&type=script&lang=js"
export * from "./BtnComprometimentoPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports